import { Sheet, Spreadsheet } from '@DStypes/project';
import CloseButton from '@components/CloseButton';
import CustomSelect from '@components/CustomSelect';
import MDButton from '@components/MDButton';
import MDTypography from '@components/MDTypography';
import { Dialog, DialogTitle, DialogContent, Grid } from '@mui/material';
import { FC, useEffect, useState } from 'react';

interface SheetSelectorProps {
  spreadsheetMetaData: Spreadsheet | undefined;
  handleClickOkButton: () => Promise<void>;
  setSelectedSheetforUpload: React.Dispatch<React.SetStateAction<string>>;
  onClose: () => void;
  initSheet: string;
}

const SheetSelector: FC<SheetSelectorProps> = ({
  spreadsheetMetaData,
  handleClickOkButton,
  setSelectedSheetforUpload,
  onClose,
  initSheet
}) => {
  const [open, setOpen] = useState<boolean>(true);
  const [sheetNames, setSheetNames] = useState<
    { label: string; value: string; disabled: boolean }[]
  >([]);
  const [selectedSheet, setSelectedSheet] = useState<string>('');

  useEffect(() => {
    if (spreadsheetMetaData) {
      setSheetNames(
        spreadsheetMetaData.sheets.map((sheet: Sheet) => ({
          label: sheet.properties.title,
          value: sheet.properties.title,
          disabled: false
        }))
      );

      setSelectedSheet(
        initSheet ? initSheet : spreadsheetMetaData.sheets[0].properties.title
      );
      setSelectedSheetforUpload(
        initSheet ? initSheet : spreadsheetMetaData.sheets[0].properties.title
      );
    }
  }, [spreadsheetMetaData]);

  const handleClickOk = () => {
    handleClickOkButton();
    setOpen(false);
  };

  // const handleClickBackdrop = (_event: any, reason: string) => {
  //   if (reason === 'backdropClick' || reason === 'escapeKeyDown')
  //     setOpen(false);
  // };

  return (
    <Dialog
      open={open}
      sx={{
        '& .MuiPaper-root': {
          width: '540px',
          maxWidth: '800px',
          position: 'relative',
          overflow: 'visible'
        }
      }}
      onClose={() => onClose()}
    >
      <CloseButton onClose={() => onClose()} />
      <DialogTitle
        sx={{ mt: 2, px: '2rem' }}
        {...({ component: 'div' } as any)}
      >
        <MDTypography
          variant='h3'
          color='secondary'
          textGradient
          sx={{ whiteSpace: 'wrap' }}
        >
          Select a sheet
        </MDTypography>
      </DialogTitle>
      <DialogContent sx={{ padding: '2rem' }}>
        <Grid container gap='20px'>
          <MDTypography
            variant='h5'
            color='info'
            sx={{ overflowWrap: 'anywhere' }}
          >
            Choose the sheet you would like to connect and select OK
          </MDTypography>
          <Grid container display='flex' justifyContent='space-between' mb={2}>
            <CustomSelect
              options={sheetNames}
              value={selectedSheet}
              sx={{ width: '80%' }}
              handleValueChange={(e: any) => {
                setSelectedSheet(e.target.value);
                setSelectedSheetforUpload(e.target.value);
              }}
            />
            <MDButton
              size='small'
              color='primary'
              variant='gradient'
              onClick={handleClickOk}
            >
              OK
            </MDButton>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default SheetSelector;
